// extracted by mini-css-extract-plugin
export default {"textTd":"Grid_textTd__q0YmB","textNote":"Grid_textNote__Yw5MW"};